import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 0.5rem;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
`;

export const Item = styled.div`
  display: flex;
  height: 125px;
  padding: 1rem;
  position: relative;
  border-radius: 0.5rem;
  flex-direction: column;
  transition: all ease 0.5s;
  justify-content: space-between;
  background-color: ${({theme}) => theme["container"]};
  border: 0.5px solid
    ${({theme}) =>
      theme["isDark"] ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.1)"};

  &::after {
    top: 0;
    left: 0;
    content: "";
    height: 100%;
    width: 0%;
    position: absolute;
    border-radius: 0.5rem;
    transition: all ease 0.3s;
    background-color: ${({theme}) => theme["primary"]};
  }
`;
